import React, { Component } from 'react';
import PropTypes from 'prop-types';
export default class Unknown extends Component {
  static propTypes = {
    type: PropTypes.string.isRequired
  }

  render() {

    return (
      <div id="kakaoContent" className="cont_plus" role="main">
        <div id="mArticle">
          <h2 id="kakaoBody" className="screen_out">오류</h2>
          <div className="info_err">
            <span className="ico_plus"></span>
            <strong className="tit_err">알 수 없는 오류가 발생했습니다.</strong>
            <p className="desc_err">
              잠시 후 다시 시도해주세요 ({this.props.type})
            </p>
          </div>
        </div>
      </div>
    );
  }
}





// WEBPACK FOOTER //
// ./src/components/ErrorContent/Unknown.js